import * as React from 'react';

const Content = () => {
    return (
        <>
            <h4>
                ANZ 8101 clinical trial results
            </h4>
            <p>
                Results of the ANZ 8101 clinical trial were published in the New England Journal of Medicine and tested strategies of continuous versus intermittent chemotherapy for metastatic breast cancer. The trial results proved important to the understanding of optimal management of metastatic disease showing not only superior tumour control with continuous chemotherapy but also better quality of life. BCT recruited 308 women to this trial.
            </p>
        </>
    );
}

export default Content;